import { Enum } from '../commons/common';

export interface ReferralInfo {
    code: string,
    irtBalance: number,
    trxBalance: number,
    referralLevelTitle: string,
    referralLevelRewardPercent: number,
    totalBalanceIRT: number,
    totalBalanceTRX: number,
    lastModifiedDate: string,
    createdOn: string,
    userCount: number,
    authenticatedUsersCount: number,
    actionCount: number,
    fullName: string,
    phoneNumber: string,
    userId: string,
    authenticatedUsersLevel1Count: number,
    authenticatedUsersLevel2Count: number,
    sumOrder: number,
}

export interface ReferralWithdrawal {
    userId?: string;
    id: string;
    fullName: string;
    phoneNumber: string;
    amount: number;
    bank: {
        iBan: string;
        cardNumber: string;
        bankName: string;
        englishBankName: string;
    };
    state: Enum;
    createdOn: string;
}

export interface ReferralAction {
    inviterUserId?: string;
    invitedUserId?: string;
    referralFullName: string;
    invitedUserFullName: string;
    orderAmount: number;
    actionAmount: number;
    type: Enum;
    orderTrackingCode: string;
    createdOn: string;
}

export enum ReferralWidthrawalState {
    Canceled = 1,
    Succeed,
    WaitingForAdmin,
    Refounded,
}
